import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import * as endpoints from '../networkUtility/endpoints'

import * as localStorageActiontype from '../LocalStorage/ActionTypes';
import { getLocalStorage } from '../LocalStorage/GetLocalStorage';

import { toggleNotificationVisibility } from './networkNotification';
import { NotificationType } from '../Utility/InterFacesAndEnum';
import { toggleLoader } from './loader'
import { handle401Status } from '../Utility/Utility';

interface templateState {
    templateObj: any,
    updateStatus: boolean
}

let updateTemplateInitialState: templateState = {
    templateObj: {},
    updateStatus: false

};

interface UpdateStatus {
    isUpdate: boolean
}


export const getUpdateTemplateDetail = createAsyncThunk(
    'get template detail',
    async (payload: string, { dispatch }) => {
        dispatch(toggleLoader({
            isLoading: true
        }));
        await fetch(`${endpoints.getSingleTemplateDetail}${payload}`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${getLocalStorage(localStorageActiontype.GET_ACCESS_TOKEN)}`,
                "Content-type": "application/json; charset=UTF-8",
            }
        })
            .then((response) => {
                return response.json();
            })
            .then((data) => {

                if (data.statusCode === 401) {
                    handle401Status();
                }

                dispatch(setUpdateTemplate({
                    templateObj: data.result
                }));
            })
            .catch(() => {
                dispatch(toggleNotificationVisibility({
                    isVisible: true,
                    status: NotificationType.error,
                    message: "Something went wrong"
                }));
            })
            .finally(() => {
                dispatch(toggleLoader({
                    isLoading: false
                }));
            })
    }
);

export const updateLotteryTemplate = createAsyncThunk(
    'Update lottery template',
    async (payload: any, { dispatch }) => {
        dispatch(toggleLoader({
            isLoading: true
        }));
        await fetch(endpoints.updateLottery, {
            method: 'PUT',
            body: JSON.stringify(payload),
            headers: {
                Authorization: `Bearer ${getLocalStorage(localStorageActiontype.GET_ACCESS_TOKEN)}`,
                "Content-type": "application/json; charset=UTF-8",
            }
        })
            .then((response) => {
                return response.json()
            })
            .then((response) => {
                console.log(response)
                if (response.statusCode === 200) {
                    dispatch(toggleNotificationVisibility({
                        isVisible: true,
                        status: NotificationType.success,
                        message: response.errorMsg
                    }));
                    dispatch(setUpdateStatus({ isUpdate: true }));
                } else {
                    dispatch(toggleNotificationVisibility({
                        isVisible: true,
                        status: NotificationType.error,
                        message: response.errorMsg
                    }));
                }

            })
            .finally(() => {
                dispatch(toggleLoader({
                    isLoading: false
                }));
            })
    }
);

const updateTemplateSlice = createSlice({
    name: 'Update Template Slice',
    initialState: updateTemplateInitialState,
    reducers: {
        setUpdateTemplate: (state, action: PayloadAction<any>) => {
            return {
                ...state,
                templateObj: action.payload.templateObj
            }
        },
        setUpdateStatus: (state, action: PayloadAction<UpdateStatus>) => {
            return {
                ...state,
                updateStatus: action.payload.isUpdate
            }
        }
    }
});

export const { setUpdateTemplate, setUpdateStatus } = updateTemplateSlice.actions;
export default updateTemplateSlice.reducer;